import React from 'react';
import { recognizeItems } from '../data/content';
export function Recognize() {
  return <section className="w-full bg-stone-100 px-5 py-20 sm:py-24" data-id="element-147" data-mp="30wohs94qq3vn">
      <div className="mx-auto max-w-4xl" data-id="element-148" data-mp="30zaxwx5p5rph">
        <div className="text-center" data-id="element-149" data-mp="2w5q0b680mzqt">
          <h2 className="text-2xl font-bold leading-tight tracking-tight text-stone-900 sm:text-3xl" data-id="element-150" data-mp="2w4nal1mfj3ch">
            <span aria-hidden="true" data-id="element-151" data-mp="2r74zp5ouqe1u">👉 </span>Do You Recognize Yourself in
            These Situations?
          </h2>
          <p className="mt-3 text-sm text-stone-600" data-id="element-152" data-mp="2m5z675ndamr9">
            If you said yes to any of these — this pack is for you.
          </p>
        </div>

        <ul className="mt-9 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-153" data-mp="2d8ovblegozmv">
          {recognizeItems.map(item => <li key={item.text} className="flex items-start gap-3 rounded-lg border border-stone-200 bg-white px-4 py-4" data-id="element-154" data-mp="28a3srfbqm3v9">
              <span className="text-base leading-none" aria-hidden="true" data-id="element-155" data-mp="6gwdg5w4jm9d">
                {item.emoji}
              </span>
              <span className="text-xs font-medium leading-snug text-stone-700" data-id="element-156" data-mp="3jkaoixfp56jx">
                {item.text}
              </span>
            </li>)}
        </ul>

        <p className="mt-10 text-center text-lg font-semibold text-orange-600 sm:text-xl" data-id="element-157" data-mp="39nfryk2zhg8a">
          And you deserve so much more than that →
        </p>
      </div>
    </section>;
}